import type { ContactState, RootState, Contact } from "@/types";
import type { GetterTree } from "vuex";

export const getters: GetterTree<ContactState, RootState> = {
  // CONTACTS
  getContacts(state): Contact[] {
    return state.contacts.data;
  },
  getContactsLoading(state): boolean {
    return state.contacts.loading;
  },
  getContactsCount(state): number {
    return state.contacts.count;
  },
  getContactsError(state): string | null {
    return state.contacts.error;
  },
};
